export enum Constraint {
  AND = "AND",
  OR = "OR",
}
